import { Box } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { useHasFeatureFlag } from "../../../Auth"
import { OnboardingPaymentPolicy } from "../../../PaymentPolicy"
import { useNavigate } from "../../../router-utils"

export default function OnboardingPaymentPolicyPage() {
	const navigate = useNavigate()
	const canIntegrateChannelManager = useHasFeatureFlag("cm_integration")
	return (
		<>
			<Helmet>
				<title>Payment Policy | Onboarding</title>
			</Helmet>
			<Box
				maxWidth="4xl"
				marginX="auto"
				padding="8"
				borderWidth="1"
				rounded="md"
				bgColor="default"
				marginBottom="16"
			>
				<Box
					borderBottomWidth="1"
					display="inlineBlock"
					fontWeight="semibold"
					marginBottom="8"
					color="primary"
					fontSize="lg"
				>
					Onboarding &gt; Policies
				</Box>
				<OnboardingPaymentPolicy
					onSuccess={() =>
						navigate(
							canIntegrateChannelManager
								? "/onboarding/channel-manager"
								: "/onboarding/invite-users"
						)
					}
				/>
			</Box>
		</>
	)
}
